import { create } from 'zustand';

export enum SignUpStep {
  CreateAccount,
  EmailVerification
}

interface SignUpStore {
  step: SignUpStep;
  name: string;
  agencyName: string;
  email: string;
  password: string;
  agreeToTerms: boolean;

  setStep: (step: SignUpStep) => void;
  setName: (name: string) => void;
  setAgencyName: (agencyName: string) => void;
  setEmail: (email: string) => void;
  setPassword: (password: string) => void;
  setAgreeToTerms: (agreeToTerms: boolean) => void;
  reset: () => void;
}

export const useSignUp = create<SignUpStore>((set) => ({
  step: SignUpStep.CreateAccount,
  name: '',
  agencyName: '',
  email: '',
  password: '',
  agreeToTerms: false,

  setStep: (step) => set({ step }),
  setName: (name) => set({ name }),
  setAgencyName: (agencyName) => set({ agencyName }),
  setEmail: (email) => set({ email }),
  setPassword: (password) => set({ password }),
  setAgreeToTerms: (agreeToTerms) => set({ agreeToTerms }),
  reset: () =>
    set({
      step: SignUpStep.CreateAccount,
      name: '',
      agencyName: '',
      email: '',
      password: '',
      agreeToTerms: false
    })
}));
